<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-richtext`]" width="1em" height="1em" v-bind="$attrs"><rect x="2" y="4" width="20" height="16.415" rx="3" stroke="#165DFF" stroke-width="1.66"/><path d="M6.85742 8.8266H9.42885M12.0003 8.8266H9.42885M9.42885 8.8266V13.1123" stroke="#00BBD8" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.2539 13.1123H17.5749M6.42578 16.5408L17.575 16.5408" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorRichtext',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
